import React, { useEffect, useState } from "react";
import { Box } from "@mui/material";
import { getAuth } from "firebase/auth";
import { getFirestore, doc, getDoc } from "firebase/firestore";
import { useAuth } from "../../config/AuthContext";
import CcpAdminDash from "./inc/CcpAdminDash";
import CcpSchoolDash from "./inc/CcpSchoolDash";
import TechPrepStaffDash from "./inc/TechPrepStaffDash";
import TechPrepAdminDash from "./inc/TechPrepAdminDash";
import TechPrepCoordinatorDash from "./inc/TechPrepCoordinatorDash";
import TechPrepInstructorDash from "./inc/TechPrepInstructorDash";
import CcpDistrictDash from "./inc/CcpDistrictDash";

const Dashboard = () => {
  const [ccpAdminFlag, setCcpAdminFlag] = useState(false);
  const [ccpFlag, setCcpFlag] = useState(false);
  const [techPrepFlag, setTechPrepFlag] = useState(false);
  const [ccpDistrictFlag, setCcpDistrictFlag] = useState(false);
  const { currentUser } = useAuth();

  useEffect(() => {
    const fetchUserProfile = async () => {
      const auth = getAuth();
      const user = auth.currentUser;
      if (user) {
        const db = getFirestore();
        const userDoc = await getDoc(doc(db, "users", user.uid));
        if (userDoc.exists()) {
          const userData = userDoc.data();
          setCcpAdminFlag(userData.ccpAdminFlag === true);
          setCcpFlag(userData.ccpSchoolFlag === true);
          setTechPrepFlag(
            userData.techPrepAdminFlag === true ||
              userData.techPrepCoordinatorFlag === true ||
              userData.techPrepInstructorFlag === true,
          );
          setCcpDistrictFlag(userData.ccpDistrictFlag === true);
        }
      }
    };

    fetchUserProfile();
  }, []);

  // Show TechPrep dashboards based on userType
  if (currentUser?.userTypes?.coordinator) {
    return (
      <Box sx={{ padding: 3, paddingTop: 8 }}>
        <TechPrepCoordinatorDash />
      </Box>
    );
  }
  if (currentUser?.userTypes?.admin) {
    return (
      <Box sx={{ padding: 3, paddingTop: 8 }}>
        <TechPrepAdminDash />
      </Box>
    );
  }
  if (currentUser?.userTypes?.instructor) {
    return (
      <Box sx={{ padding: 3, paddingTop: 8 }}>
        <TechPrepInstructorDash />
      </Box>
    );
  }
  if (currentUser?.userTypes?.staff) {
    return (
      <Box sx={{ padding: 3, paddingTop: 8 }}>
        <TechPrepStaffDash />
      </Box>
    );
  }

  return (
    <Box sx={{ padding: 3, paddingTop: 8 }}>
      {ccpAdminFlag && <CcpAdminDash />}
      {ccpFlag && <CcpSchoolDash />}
      {techPrepFlag && <TechPrepStaffDash />}
      {ccpDistrictFlag && <CcpDistrictDash />}
    </Box>
  );
};

export default Dashboard;
